import React from 'react';

import Button  from 'reactstrap-button-loader';
const ButtonWithLoader = (props)=>{
    return (
        <Button {...props} />
    )
}
export default ButtonWithLoader;